import { motion } from "framer-motion";
import ClientReviews from "@/components/ClientReviews";

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative py-24 bg-gray-900">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{
            backgroundImage: `url('/assets/PDM07398.webp')`,
            backgroundPositionY: "75%", // Centered vertically
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-white mb-6"
          >
            About Ecoplace Tours
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-lg text-gray-300 max-w-2xl mx-auto"
          >
            Your trusted partner for authentic African safari experiences
          </motion.p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <img
              src="/assets/PDM07601.webp"
              loading="lazy"
              alt="Our team at the falls"
              className="rounded-lg shadow-xl w-full h-[400px] object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h2 className="text-3xl font-bold">About Us</h2>
            <p className="text-gray-600">
              Ecoplace Tours Limited is a pioneering sustainable tour and travel operator nestled in the heart of uganda dedicated to providing unforgettable experiences across the east African region. Our commitment to Eco-Centric tourism sets us apart, as we weave together vibrant tapestry of Uganda, Kenya, Tanzania and Rwanda.
            </p>
            <p className="text-gray-600">
              We specialize in wildlife encounters that embrace conservation ethics, And we offer a range of soft and extreme adventure experiences for the daring Explorer...
            </p>
          </motion.div>
        </div>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
            <p className="text-gray-600">
              To provide exceptional safari experiences while promoting
              conservation and supporting local communities.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h3 className="text-2xl font-bold mb-4">Expert Guides</h3>
            <p className="text-gray-600">
              Our guides are certified professionals with extensive knowledge of
              Uganda's wildlife and landscapes.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h3 className="text-2xl font-bold mb-4">Sustainability</h3>
            <p className="text-gray-600">
              We're committed to eco-friendly practices and supporting wildlife
              conservation efforts.
            </p>
          </motion.div>
        </div>

        {/* Smaller version of client reviews with no bottom margin */}
        <div className="mt-24 mb-0">
          <ClientReviews className="max-w-4xl mx-auto scale-90 !pb-0" />
        </div>
      </div>
    </div>
  );
}
